module.exports = __webpack_public_path__ + "static/media/报名页面banner_01.d79f6c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/awards/images/报名页面banner_01.png
// module id = 1194
// module chunks = 0